import { goBack, push, replace as replaceURL } from 'react-router-redux';
import config from '../config';

export function back() {
  return (dispatch) => {
    dispatch(goBack());
  };
}

export function replace(url) {
  return (dispatch) => {
    dispatch(replaceURL(url));
  };
}

export function goTo(url) {
  return (dispatch) => {
    if(url.includes(config.webview.lifeFEPath)){
      window.location.href = `${window.location.origin}${url}`;
    } else {
      dispatch(push(url));
    }
  };
}

export function attachQuery(queryObj) {
  return (dispatch, getState) => {
    const { pathname } = getState().routing.locationBeforeTransitions;

    const query = Object.keys(queryObj)
      .filter(key => !!queryObj[key])
      .map(key => `${key}=${queryObj[key]}`)
      .join('&');

    if (query)
      dispatch(replaceURL(`${pathname}?${query}`));
  };
}
